import Swiper from "swiper/bundle";

// Add more customisation depending on needs
function createSwiper(swiperClass, swiperLoop, slidesPerViewDesktop, slidesPerViewMobile, spaceBetween) {
  new Swiper(swiperClass, {
    spaceBetween: spaceBetween,
    loop: swiperLoop == "true",
    centerInsufficientSlides: true,
    direction: "horizontal",

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },

    breakpoints: {
      320: {
        slidesPerView: isNaN(slidesPerViewMobile) ? "auto" : slidesPerViewMobile,
      },
      768: {
        slidesPerView: isNaN(slidesPerViewDesktop) ? "auto" : slidesPerViewDesktop,
      },
    },
  });
}

window.addEventListener("load", function () {
  document
    .querySelectorAll("[class^='swiper-container'")
    .forEach((e) =>
      createSwiper(
        e.dataset.swiperContainerClass,
        e.dataset.swiperLoop,
        parseInt(e.dataset.slidesPerViewDesktop),
        parseInt(e.dataset.slidesPerViewMobile),
        parseInt(e.dataset.spaceBetween)
      )
    );
});
